export default __webpack_public_path__ + "static/media/instagramLogo.37ce13b7.svg";